export const NEXT_STEP = 'app/FormWizard/NEXT_STEP';
export const BACK_STEP = 'app/FormWizard/BACK_STEP';
export const GO_STEP = 'app/FormWizard/GO_STEP';
export const SET_LAST_VISITED_STEP = 'app/FormWizard/SET_LAST_VISITED_STEP';
export const SET_HAS_SUBMITTED = 'app/FormWizard/SET_HAS_SUBMITTED';
export const UPDATE_INITIAL_VALUES = 'app/FormWizard/UPDATE_INITIAL_VALUES';
export const SET_VALUES = 'app/FormWizard/SET_VALUES';
export const SET_DEFAULT_STEPS = 'app/FormWizard/SET_DEFAULT_STEPS';
export const NAVIGATION_ENUM = Object.freeze({
  NEXT: 'Next',
  BACK: 'Back',
  SUBMIT: 'Submit',
});
export const DEFAULT_STEPS = [
  { stepName: 'Filing Status', isCompleted: false },
  { stepName: 'Current Age', isCompleted: false },
  { stepName: 'Start Age', isCompleted: false },
  { stepName: 'Social Security Benefit', isCompleted: false },
  { stepName: 'Reduction Amount', isCompleted: false },
];
